import(/* webpackMode: "eager", webpackExports: ["MeProvider"] */ "/vercel/path0/packages/features/auth/src/providers/me/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["I18nClientProvider"] */ "/vercel/path0/packages/shared/i18n/src/provider/i18n-client.provider.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/shared/router/src/components/button-link.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/shared/router/src/components/link.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/shared/router/src/components/locale-switcher.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/shared/router/src/hooks/router-provider.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/shared/router/src/hooks/use-decode-pathname-with-query-params.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/shared/router/src/hooks/use-decode-pathname.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/shared/router/src/hooks/use-router.ts");
